module.exports = __webpack_public_path__ + "static/media/external-link.341c5eb6.svg";